import { render, staticRenderFns } from "./SaleOrderMonitoring.vue?vue&type=template&id=1b49511c&scoped=true"
import script from "./SaleOrderMonitoring.vue?vue&type=script&lang=js"
export * from "./SaleOrderMonitoring.vue?vue&type=script&lang=js"
import style0 from "./SaleOrderMonitoring.vue?vue&type=style&index=0&id=1b49511c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b49511c",
  null
  
)

export default component.exports